<template>
  <div class="custom-anti-red-management">
    <div class="header" v-fade-in>
      <h3>用户自定义防红接口</h3>
      <button class="refresh-btn" @click="loadLinks" :disabled="loading">
        {{ loading ? '加载中...' : '刷新' }}
      </button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>
    <div v-else-if="links.length === 0" class="empty">暂无用户自定义接口</div>
    <div v-else class="table-container" v-motion="{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.4, delay: 0.05 } }">
      <table class="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>用户</th>
            <th>接口名称</th>
            <th>防红域名</th>
            <th>状态</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="link in links" :key="link.id">
            <td>{{ link.id }}</td>
            <td>{{ link.username }}</td>
            <td>{{ link.name }}</td>
            <td class="url-cell">
              <div class="url-wrapper">
                <span class="url-text" :title="link.apiUrl">{{ link.apiUrl }}</span>
                <button class="copy-btn" @click="copyUrl(link.apiUrl)" title="复制链接">复制</button>
              </div>
            </td>
            <td>
              <span :class="['status-badge', link.isActive ? 'active' : 'inactive']">
                {{ link.isActive ? '已启用' : '未启用' }}
              </span>
            </td>
            <td>{{ formatTime(link.createdAt) }}</td>
            <td>
              <button class="delete-btn" @click="deleteLink(link)">删除</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiFetch } from '@/config/api'

export default {
  name: 'CustomAntiRedManagement',
  data() {
    return {
      links: [],
      loading: false
    }
  },
  mounted() {
    this.loadLinks()
  },
  methods: {
    async loadLinks() {
      this.loading = true
      try {
        const res = await apiFetch('/api/custom-anti-red/admin/all')
        if (res.code === 0) {
          this.links = res.data || []
        }
      } catch (e) {
        console.error('加载失败:', e)
      } finally {
        this.loading = false
      }
    },
    async deleteLink(link) {
      if (!confirm(`确定删除用户 ${link.username} 的接口「${link.name}」？`)) return
      try {
        const res = await apiFetch(`/api/custom-anti-red/admin/delete/${link.id}`, { method: 'DELETE' })
        if (res.code === 0) {
          this.loadLinks()
        } else {
          alert(res.msg || '删除失败')
        }
      } catch (e) {
        alert('删除失败')
      }
    },
    copyUrl(url) {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          alert('链接已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopy(url)
        })
      } else {
        this.fallbackCopy(url)
      }
    },
    fallbackCopy(url) {
      const textarea = document.createElement('textarea')
      textarea.value = url
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        alert('链接已复制到剪贴板')
      } catch (e) {
        alert('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.custom-anti-red-management { padding: 0; }
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.header h3 { margin: 0; font-size: 15px; font-weight: 600; color: #111; }
.refresh-btn { padding: 6px 14px; background: #111; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 13px; }
.refresh-btn:hover { background: #333; }
.refresh-btn:disabled { background: #ccc; cursor: not-allowed; }
.loading, .empty { text-align: center; padding: 40px; color: #999; font-size: 14px; }
.table-container { overflow-x: auto; background: #fff; border: 1px solid #e8e8e8; }
.data-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.data-table th, .data-table td { padding: 10px 12px; text-align: left; border-bottom: 1px solid #f0f0f0; }
.data-table th { background: #fafafa; font-weight: 600; font-size: 12px; color: #666; text-transform: uppercase; letter-spacing: 0.3px; }
.data-table tr:hover { background: #fafafa; }
.url-cell { max-width: 400px; }
.url-wrapper { display: flex; align-items: center; gap: 8px; }
.url-text { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-family: monospace; font-size: 12px; color: #666; }
.copy-btn { padding: 3px 8px; background: #fff; color: #333; border: 1px solid #ddd; border-radius: 3px; cursor: pointer; font-size: 12px; white-space: nowrap; flex-shrink: 0; }
.copy-btn:hover { background: #f5f5f5; border-color: #111; }
.status-badge { padding: 2px 8px; border-radius: 3px; font-size: 12px; border: 1px solid; }
.status-badge.active { background: #fff; color: #111; border-color: #111; }
.status-badge.inactive { background: #fff; color: #999; border-color: #ddd; }
.delete-btn { padding: 4px 10px; background: #fff; color: #666; border: 1px solid #ddd; border-radius: 3px; cursor: pointer; font-size: 12px; }
.delete-btn:hover { background: #111; color: #fff; border-color: #111; }
</style>
